module.exports = __webpack_public_path__ + "static/media/pk_switch.215a8061.jpg";